import { SLASH_COMMAND } from 'config';

import React, { PropTypes } from 'react';

const SlashCommand = ({ className = 'red', suffix = '' }) => (
  <code className={`normal ${className}`}>/{SLASH_COMMAND}{suffix}</code>
);

SlashCommand.defaultProps = {
  className: 'red',
  suffix: '',
};

SlashCommand.propTypes = {
  className: PropTypes.string.isRequired,
  suffix: PropTypes.string.isRequired,
};

export default SlashCommand;



/** WEBPACK FOOTER **
 ** ./src/components/SlashCommand.jsx
 **/